module.exports = __webpack_public_path__ + "resources/objects-d5f32382e5b1a4ab69763b0892fca717.svg";